export default "__VITE_ASSET__CtN4Zfhz__"